import {fetchApi} from "../fetch";
import {API_URL} from "../../constants/axios";

export const getProductList = async (ids, valid, page = 1) => {
    const searchParam = new URLSearchParams({"page": page});
    if (ids) {
        searchParam.append("ids", ids)
    }
    if (valid) {
        searchParam.append("valid", valid)
    }
    const res = await fetchApi.get(`${API_URL.PRODUCT_LIST}?${searchParam.toString()}`)
    return res.data;
}

export const getProductDetail = async (id, productCode) => {
    const searchParam = new URLSearchParams({});
    if (id) { searchParam.append("id", id) }
    if (productCode) { searchParam.append("productCode", productCode) }

    const res = await fetchApi.get(`${API_URL.PRODUCT_DETAIL}?${searchParam.toString()}`)

    return res.data;
}

export const saveProduct = async (id, product) => {
    const res = await fetchApi.post(`${API_URL.PRODUCT_DETAIL.replace("{id}", id)}`,
        product)
    return res.data;
}

export const deleteProduct = async (id, product) => {
    const res = await fetchApi.post(`${API_URL.PRODUCT_DELETE.replace("{id}", id)}`,
        product)
    return res.data;
}

export const productRegistration = async (url) => {
    const res = await fetchApi.get(`${API_URL.PRODUCT_REGISTRATION}?url=${url}`)
    return res.data
}